module.exports = __webpack_public_path__ + "media/img/scholarship_types/Creative Scholarships-480e0848a04b95553e8552a6eb972867.svg";